"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var Util_1 = require("../../../../../../../Services/Util");
var TransactionIdFilter = /** @class */ (function (_super) {
    __extends(TransactionIdFilter, _super);
    function TransactionIdFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.search = function () {
            var _a;
            var transactionId = (_a = _this.transactionIdInput.current) === null || _a === void 0 ? void 0 : _a.value;
            if (Util_1.isNullOrWhiteSpace(transactionId)) {
                _this.setState({ transactionIdIsInvalid: true });
            }
            else {
                _this.props.fetchResults({
                    transactionId: transactionId
                });
            }
        };
        _this.transactionIdInput = React.createRef();
        _this.state = {
            transactionIdIsInvalid: false
        };
        return _this;
    }
    TransactionIdFilter.prototype.render = function () {
        var _this = this;
        return (React.createElement(reactstrap_1.Row, { style: { alignItems: "center" } },
            React.createElement(reactstrap_1.Col, null,
                React.createElement(reactstrap_1.InputGroup, null,
                    React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                        React.createElement(reactstrap_1.InputGroupText, null, this.props.resources.TransactionId)),
                    React.createElement(reactstrap_1.Input, { innerRef: this.transactionIdInput, invalid: this.state.transactionIdIsInvalid, onChange: function () { if (_this.state.transactionIdIsInvalid) {
                            _this.setState(__assign(__assign({}, _this.state), { transactionIdIsInvalid: false }));
                        } } }),
                    this.state.transactionIdIsInvalid && React.createElement(reactstrap_1.FormFeedback, null, this.props.resources.Registration_Validation_RequiredField))),
            React.createElement(reactstrap_1.Col, { xs: "auto", style: { display: "flex", justifyContent: "center", alignItems: "center" } },
                React.createElement(reactstrap_1.Button, { size: "lg", outline: true, color: "primary", onClick: this.search },
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSearch })))));
    };
    return TransactionIdFilter;
}(React.Component));
exports.TransactionIdFilter = TransactionIdFilter;
//# sourceMappingURL=TransactionIdFilter.js.map